<!-- modal -->
<div class="p-6">
  <div class="mb-3 flex items-center justify-between">
    <h6 class="mb-3 text-sm font-semibold text-slate-800">Teléfonos</h6>
    <button
      class="ml-auto inline-flex h-8 items-center gap-1 rounded-lg bg-emerald-600 px-3 text-xs font-semibold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:opacity-60"
      (click)="abrirModal({ template: modalAgregarTelefono })"
      title="Agregar teléfono"
    >
      <i class="bi bi-plus-circle"></i> Agregar
    </button>
  </div>
  <div class="overflow-hidden rounded-xl border border-slate-200">
    <table class="min-w-full divide-y divide-slate-200 text-sm">
      <thead class="bg-slate-50">
        <tr>
          <th class="px-4 py-3 text-left font-semibold text-slate-600">#</th>
          <th class="px-4 py-3 text-left font-semibold text-slate-600">
            Número
          </th>
          <th class="px-4 py-3 text-left font-semibold text-slate-600">
            Título
          </th>
          <th class="px-4 py-3 text-left font-semibold text-slate-600">
            Descripción
          </th>
          <th class="px-4 py-3 text-left font-semibold text-slate-600">
            Estado
          </th>
          <th class="px-4 py-3 text-left font-semibold text-slate-600">
            Proveedor
          </th>
          <th class="px-4 py-3 text-right font-semibold text-slate-600">
            Control
          </th>
        </tr>
      </thead>
      <tbody class="divide-y divide-slate-200 bg-white">
        @for (telefono of sucursal().telefonos; track telefono.id) {
          <tr class="hover:bg-slate-50">
            <td class="px-4 py-3 text-slate-600">{{ $index + 1 }}</td>
            <td class="px-4 py-3 text-slate-800">{{ telefono.numero }}</td>
            <td class="px-4 py-3 text-slate-800">{{ telefono.titulo }}</td>
            <td class="px-4 py-3 text-slate-600">
              {{ telefono.descripcion || "-" }}
            </td>
            <td class="px-4 py-3">
              @if (telefono.activo) {
                <span
                  class="rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-medium text-emerald-700"
                  >Activo</span
                >
              } @else {
                <span
                  class="rounded-full bg-slate-200 px-2 py-0.5 text-xs font-medium text-slate-700"
                  >Inactivo</span
                >
              }
            </td>
            <td class="px-4 py-3">
              @if (telefono.proveedor === 'NO_OFICIAL') {
                <span
                  class="rounded-full bg-purple-100 px-2 py-0.5 text-xs font-medium text-purple-700"
                  >No oficial</span
                >
              } @else {
                <span
                  class="rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700"
                  >Oficial</span
                >
              }
            </td>
            <td class="px-4 py-3 text-right">
              <div class="inline-flex gap-2">
                <button
                  type="button"
                  class="rounded-lg border border-sky-300 px-2.5 py-1.5 text-sky-700 transition hover:bg-sky-50 disabled:cursor-not-allowed disabled:opacity-60"
                  (click)="
                    abrirModal({
                      template: modalEditarTelefono,
                      telefonoEditing: telefono,
                    })
                  "
                >
                  <i class="bi bi-pencil"></i>
                </button>
                <button
                  type="button"
                  class="rounded-lg border border-blue-300 px-2.5 py-1.5 text-blue-700 transition hover:bg-blue-50 disabled:cursor-not-allowed disabled:opacity-60"
                  (click)="
                    abrirModal({
                      template: modalCreditoWhatsapp,
                      telefonoEditing: telefono,
                    })
                  "
                >
                  <i class="bi bi-currency-dollar"></i>
                </button>
                <button
                  type="button"
                  class="rounded-lg border border-red-300 px-2.5 py-1.5 text-red-700 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-60"
                  (click)="
                    abrirModal({
                      template: modalEliminarTelefono,
                      telefonoEditing: telefono,
                    })
                  "
                >
                  <i class="bi bi-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        } @empty {
          <tr>
            <td
              colspan="6"
              class="px-4 py-10 text-center text-sm text-slate-500"
            >
              No hay teléfonos registrados para esta sede.
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="mt-6">
    <div class="mb-3 flex items-center justify-between">
      <h6 class="text-sm font-semibold text-slate-800">
        Historial de créditos WhatsApp
      </h6>
    </div>

    <div class="mb-3 grid grid-cols-1 gap-3 md:grid-cols-4">
      <div>
        <label class="mb-1 block text-xs font-semibold text-slate-600"
          >Fecha desde</label
        >
        <input
          type="date"
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-sky-500 focus:outline-none"
          [value]="fechaDesde()"
          (change)="onFechaDesdeChange($any($event.target).value)"
        />
      </div>

      <div>
        <label class="mb-1 block text-xs font-semibold text-slate-600"
          >Fecha hasta</label
        >
        <input
          type="date"
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-sky-500 focus:outline-none"
          [value]="fechaHasta()"
          (change)="onFechaHastaChange($any($event.target).value)"
        />
      </div>

      <div>
        <label class="mb-1 block text-xs font-semibold text-slate-600"
          >Teléfono</label
        >
        <select
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-sky-500 focus:outline-none"
          [value]="telefonoFiltroId() || ''"
          (change)="onTelefonoFiltroChange($any($event.target).value)"
        >
          <option value="">Todos</option>
          @for (telefono of sucursal().telefonos; track telefono.id) {
            <option [value]="telefono.id">
              {{ telefono.titulo }} - {{ telefono.numero }}
            </option>
          }
        </select>
      </div>

      <div class="flex items-end gap-2">
        <button
          type="button"
          class="rounded-lg bg-sky-600 px-3 py-2 text-xs font-semibold text-white transition hover:bg-sky-700"
          (click)="aplicarFiltrosHistorial()"
        >
          Buscar
        </button>
        <button
          type="button"
          class="rounded-lg border border-slate-300 px-3 py-2 text-xs font-semibold text-slate-700 transition hover:bg-slate-100"
          (click)="limpiarFiltrosHistorial()"
        >
          Limpiar
        </button>
      </div>
    </div>

    <div class="overflow-hidden rounded-xl border border-slate-200">
      <table class="min-w-full divide-y divide-slate-200 text-sm">
        <thead class="bg-slate-50">
          <tr>
            <th class="px-4 py-3 text-left font-semibold text-slate-600">#</th>
            <th class="px-4 py-3 text-left font-semibold text-slate-600">
              Fecha
            </th>
            <th class="px-4 py-3 text-left font-semibold text-slate-600">
              Teléfono
            </th>
            <th class="px-4 py-3 text-left font-semibold text-slate-600">
              Detalle
            </th>
            <th class="px-4 py-3 text-right font-semibold text-slate-600">
              Antes
            </th>
            <th class="px-4 py-3 text-right font-semibold text-slate-600">
              Nuevo
            </th>
            <th class="px-4 py-3 text-right font-semibold text-slate-600">
              Delta
            </th>
          </tr>
        </thead>

        <tbody class="divide-y divide-slate-200 bg-white">
          @if (loadingHistorial()) {
            <tr>
              <td
                colspan="7"
                class="px-4 py-8 text-center text-sm text-slate-500"
              >
                Cargando historial...
              </td>
            </tr>
          } @else {
            @for (log of historialCreditos(); track log.id) {
              <tr class="hover:bg-slate-50">
                <td class="px-4 py-3 text-slate-600">{{ $index + 1 }}</td>
                <td class="px-4 py-3 text-slate-700">
                  {{ log.created_at | date: "dd/MM/yyyy HH:mm" }}
                </td>
                <td class="px-4 py-3 text-slate-800">
                  {{ log.telefono_titulo }} - {{ log.telefono_numero }}
                </td>
                <td class="px-4 py-3 text-slate-600">
                  <button
                    type="button"
                    class="rounded-lg border border-indigo-300 px-2.5 py-1.5 text-xs font-semibold text-indigo-700 transition hover:bg-indigo-50"
                    (click)="verMotivo(log, modalMotivoHistorial)"
                  >
                    Ver motivo
                  </button>
                </td>
                <td class="px-4 py-3 text-right text-slate-700">
                  {{ log.creditos_anteriores }}
                </td>
                <td class="px-4 py-3 text-right text-slate-700">
                  {{ log.creditos_nuevos }}
                </td>
                <td
                  class="px-4 py-3 text-right font-semibold"
                  [class.text-emerald-700]="log.delta_creditos > 0"
                  [class.text-red-700]="log.delta_creditos < 0"
                  [class.text-slate-700]="log.delta_creditos === 0"
                >
                  {{ log.delta_creditos }}
                </td>
              </tr>
            } @empty {
              <tr>
                <td
                  colspan="7"
                  class="px-4 py-8 text-center text-sm text-slate-500"
                >
                  No hay movimientos de créditos para los filtros seleccionados.
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #modalAgregarTelefono let-modal>
  <app-modal-agregar-telefono
    [sucursalId]="sucursal().id"
    (cerrar)="cerrarModal(modalAgregarTelefono)"
    (agregarTelefono)="
      onTelefonoAgregado($event); cerrarModal(modalAgregarTelefono)
    "
  />
</ng-template>

<ng-template #modalEditarTelefono let-modal>
  @if (telefonoEditing() != null) {
    <app-modal-editar-telefono
      [sucursalId]="sucursal().id"
      [telefono]="telefonoEditing()!"
      (cerrar)="cerrarModal(modalEditarTelefono)"
      (telefonoEditado)="onTelefonoEditado($event)"
    />
  }
</ng-template>

<ng-template #modalEliminarTelefono let-modal>
  @if (telefonoEditing() != null) {
    <app-modal-eliminar-telefono
      [sucursalId]="sucursal().id"
      [telefono]="telefonoEditing()!"
      (cerrar)="cerrarModal(modalEliminarTelefono)"
      (telefonoEliminado)="onTelefonoEliminado($event)"
    />
  }
</ng-template>

<ng-template #modalCreditoWhatsapp let-modal>
  @if (
    telefonoEditing() != null && telefonoEditing()!.creditoWhatsapp != null
  ) {
    <app-modal-actualizar-credito-whatsapp
      [sucursalId]="sucursal().id"
      [creditoWhatsapp]="telefonoEditing()!.creditoWhatsapp!"
      (cerrar)="cerrarModal(modalCreditoWhatsapp)"
      (creditoActualizado)="onCreditoActualizado($event)"
    />
  }
</ng-template>

<ng-template #modalMotivoHistorial let-modal>
  @if (historialLogSeleccionado() != null) {
    <div class="w-full rounded-xl bg-white p-6 shadow-xl">
      <div class="mb-4 flex items-start justify-between gap-3">
        <h6 class="text-base font-semibold text-slate-800">
          Motivo del movimiento
        </h6>
        <button
          type="button"
          class="rounded-lg border border-slate-300 px-2 py-1 text-xs text-slate-600 transition hover:bg-slate-100"
          (click)="cerrarModal(modalMotivoHistorial)"
        >
          Cerrar
        </button>
      </div>

      <div
        class="mb-3 grid grid-cols-1 gap-2 text-xs text-slate-600 sm:grid-cols-2"
      >
        <div>
          <span class="font-semibold text-slate-700">Fecha:</span>
          {{
            historialLogSeleccionado()!.created_at | date: "dd/MM/yyyy HH:mm"
          }}
        </div>
        <div>
          <span class="font-semibold text-slate-700">Teléfono:</span>
          {{ historialLogSeleccionado()!.telefono_titulo }}
        </div>
      </div>

      <div
        class="rounded-lg border border-slate-200 bg-slate-50 p-4 text-sm text-slate-700"
      >
        {{ historialLogSeleccionado()!.motivo }}
      </div>
    </div>
  }
</ng-template>
